import React from 'react';
import { Helmet } from 'react-helmet';
import { graphql, useStaticQuery } from 'gatsby';

const Breadcrumb = ({ data }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            siteUrl
          }
        }
      }
    `
  );

  return (
    <Helmet>
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "Inicio",
              "item": "${site.siteMetadata.siteUrl}"
            }
            ${data.map(
              ({ name, slug }, index) => `
              ,{
                  "@type": "ListItem",
                  "position": ${index + 2},
                  "name": "${name}",
                  "item": "${site.siteMetadata.siteUrl}/${slug}"
                }]
              }`
            )}
      `}
      </script>
    </Helmet>
  );
};

export default Breadcrumb;
